function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Sort"
}, /*#__PURE__*/React.createElement("title", null, "VF_Dutch_Icons_3rdWave"), /*#__PURE__*/React.createElement("path", {
  d: "M263.4 189.6l-39.8 39.7.1-229.3h-28.4v229.2l-39.7-39.7-20.1 20.1 74 73.9 74-73.9zM0 28.2h148.8v28.4H0zM0 198.8h92.6v28.4H0zM0 113.2h149.4v28.4H0z"
}))));